import { call, put, takeLatest } from 'redux-saga/effects'
import { PaymentsActions, PaymentsTypes } from './paymentsSlice'
import api from '../../services/api'

function* initializePaymentSaga(action) {
  const { amount, bookingId = null, listingId = null } = action
  const response = yield call(api.initializePayment, amount, bookingId, listingId)

  if (response.ok) {
    yield put(PaymentsActions.initializePaymentSuccess(response.data))
  } else {
    const errorMsg = response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem
    yield put(PaymentsActions.initializePaymentFailure(errorMsg))
  }
}

function* getMyPaymentsSaga(action) {
  const { options } = action
  const response = yield call(api.getMyPayments, options)

  if (response.ok) {
    yield put(PaymentsActions.fetchingMyPaymentsSuccess(response.data))
  } else {
    const errorMsg = response.data?.message || response.data?.error_description || response.data?.detail || response.data?.title || response.data?.description || response.data?.error || (typeof response.data === 'string' ? response.data : null) || response.problem
    yield put(PaymentsActions.fetchingMyPaymentsFailure(errorMsg))
  }
}

export default function* paymentsSaga() {
  yield takeLatest(PaymentsTypes.INITIALIZE_PAYMENT_REQUEST, initializePaymentSaga)
  yield takeLatest(PaymentsTypes.FETCHING_MY_PAYMENTS_REQUEST, getMyPaymentsSaga)
}